import { render, staticRenderFns } from "./product-list.vue?vue&type=template&id=1bd12f1e&scoped=true&"
import script from "./product-list.vue?vue&type=script&lang=js&"
export * from "./product-list.vue?vue&type=script&lang=js&"
import style0 from "./product-list.vue?vue&type=style&index=0&id=1bd12f1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd12f1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bd12f1e')) {
      api.createRecord('1bd12f1e', component.options)
    } else {
      api.reload('1bd12f1e', component.options)
    }
    module.hot.accept("./product-list.vue?vue&type=template&id=1bd12f1e&scoped=true&", function () {
      api.rerender('1bd12f1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/fee_regular/DaShan_budget_rules/form/product-list.vue"
export default component.exports